import { render, staticRenderFns } from "./field-type-list.vue?vue&type=template&id=5fe512f0&"
import script from "./field-type-list.vue?vue&type=script&lang=js&"
export * from "./field-type-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports